import React, { useEffect, useMemo, useState } from "react";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

const useUpcommingTable = () => {
  const [PlayersData, setPlayersData] = useState([]);

  const fetchPlayers = async () => {
    try {
      const response = await apiService.get("/bookings?filter=upcoming");
      setPlayersData(response.data);
    } catch (errors) {
      handleError(errors)
    }
  };

  useEffect(() => {
    fetchPlayers();
  }, []);

  // Define the columns for the table
  const columns = React.useMemo(
    () => [
      {
        Header: "PLAYERS",
        accessor: "players",
        headerAlign: "text-center",
        cellAlign: "text-center",
        Cell: ({ value, row }) => {
          const playerNames = value.split(",").map((name) => name.trim());

          return (
            <div className=" group relative">
              <ul className="flex flex-wrap justify-start lg:justify-center items-center ">
                {playerNames.slice(0, 1).map((name, index) => (
                  <li key={index} className="break-words whitespace-normal">
                    {name}
                    {index !== playerNames.length - 1 && " / "}
                  </li>
                ))}
                {playerNames.length > 1 && <span className="font-bold"> ...</span>}
              </ul>

              {/* Full list visible on hover */}
              {playerNames.length > 1 && (
                <div className="w-[250px] absolute bg-white shadow-lg p-2 rounded-md border border-gray-300 z-40 hidden group-hover:block">
                  <span>{playerNames.join(" / ")}</span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "TABLE",
        accessor: "tableType",
      },
      {
        Header: "TIME",
        accessor: "time",
        Cell: ({ value }) => (<div className="text-nowrap">{value}</div>)
      },
    ],
    []
  );

  // Sample data for the table
  const data = useMemo(() => {
    if (!Array.isArray(PlayersData)) return [];
    return PlayersData?.map((item) => ({
      id: item.id,
      tableType: item.table_type,
      players:
        item.players && item.players.length > 0
          ? item.players.map((player) => player.name).join(", ")
          : "No players",
      start_date: item.start_date.split("T")[0],
      time: item.start_time,
    }));
  }, [PlayersData]);

  return { columns, data, fetchPlayers };
};

export default useUpcommingTable;
